module.exports = __webpack_public_path__ + "img/allerton_b1.15912c7c.jpg";